import * as React from 'react';
import { observer } from 'mobx-react';
import { PageTitleLoaded } from '.';
import { useStores } from 'utility/hooks';

export const PageTitle = observer(() => {
  const { pageTitleStore } = useStores();
  const { loading } = pageTitleStore;

  return loading ? null : <PageTitleLoaded />;
});
